import type { SearchHandlingUnitTypesParams } from './handling-unit-type.api';

export const handlingUnitTypeKeys = {
  all: ['handling-unit-types'] as const,
  list: (params: SearchHandlingUnitTypesParams): readonly unknown[] =>
    [...handlingUnitTypeKeys.lists(), params] as const,
  lists: (): readonly string[] => [...handlingUnitTypeKeys.all, 'list'] as const,
};
